import React from 'react';

import { flagStyles } from '../settings';

const SvgMD = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3288px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMD;
